<glxy-form-field [required]="required">
  <glxy-label>
    {{ label | translate }}
  </glxy-label>
  <input [formControl]="numberInputControl" matInput step="0.001" type="number" [id]="id" />
  <automata-automation-variable-menu
    *ngIf="showVariableItemMenu"
    matSuffix
    useGalaxyCompat="true"
    [dontIncludeDefaultCategories]="true"
    [supportedDataTypes]="supportedDataTypes"
    (variableSelected)="insertTheVariable(numberInputControl, $event)"
  ></automata-automation-variable-menu>
</glxy-form-field>
